import { AppLocale, toAppLocale } from '@shared/lib/locale'

/** Ролик-инструкция. Нет ID на языке интерфейса — берётся русский. */
export interface InstructionVideo {
  id: string
  /** YouTube ID по языкам; `ru` обязателен. */
  videoIds: { ru: string } & Partial<Record<AppLocale, string>>
  /** Ключи неймспейса `participant`. */
  titleKey: string
  textKey: string
}

/** Новый ролик — одна запись здесь + два ключа в `participant.json`. */
export const INSTRUCTION_VIDEOS: InstructionVideo[] = [
  {
    id: 'registration',
    videoIds: { ru: 'VoxTHevRhHE' },
    titleKey: 'instructions.registration.title',
    textKey: 'instructions.registration.text',
  },
]

/** ID ролика на языке интерфейса; если на нём ролика нет — русский. */
export function pickVideoId(videoIds: InstructionVideo['videoIds'], lang: string): string {
  return videoIds[toAppLocale(lang)] ?? videoIds.ru
}

/** Запись списка, ролик которой показывает карточка в сайдбаре. */
const SIDEBAR_VIDEO_ID = 'registration'

/** Ролик, который показывает карточка в сайдбаре (по `id`, а не по месту в списке). */
export const SIDEBAR_VIDEO: InstructionVideo = (() => {
  const video = INSTRUCTION_VIDEOS.find((v) => v.id === SIDEBAR_VIDEO_ID)
  if (!video) throw new Error(`Нет ролика сайдбара: ${SIDEBAR_VIDEO_ID}`)
  return video
})()
